import * as i0 from '@angular/core';
import { Injectable, PLATFORM_ID, Inject, Optional, ComponentFactoryResolver, NgModule } from '@angular/core';
import { isPlatformBrowser, DOCUMENT, isPlatformServer } from '@angular/common';
import { Subscription, Subject, fromEvent, of } from 'rxjs';
import { EquisCurrencyTypes } from '@tn-equis/core/utils';

class EquisChildCheckService {
    constructor() { }
    // radiobutton
    checkRadio(list, index) {
        const element = list[index];
        if (element.checked) {
            return list;
        }
        list.forEach((e) => {
            e.checked = false;
        });
        element.checked = true;
        return list;
    }
    // sin cambios
    checkInput(list, index) {
        return list;
    }
    // checkbox
    checkSelect(list, index) {
        const element = list[index];
        element.checked = !element.checked;
        return list;
    }
}
EquisChildCheckService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisChildCheckService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
EquisChildCheckService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisChildCheckService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisChildCheckService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class EquisComponentPersistanceService {
    constructor() {
        this.elementList = [];
        this.idCounter = 0;
    }
    addElement(instance, parent) {
        const id = this.idCounter.toString();
        this.idCounter += 1;
        this.elementList.push({ id, instance, parent });
        return id;
    }
    getElement(id) {
        return this.elementList.find((el) => el.id === id);
    }
    getElementInstance(id) {
        const element = this.getElement(id);
        return element ? element.instance : null;
    }
    getElementParent(id) {
        const element = this.getElement(id);
        return element ? element.parent : null;
    }
    removeElement(id) {
        this.elementList = this.elementList.filter((el) => el.id !== id);
    }
}
EquisComponentPersistanceService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisComponentPersistanceService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
EquisComponentPersistanceService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisComponentPersistanceService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisComponentPersistanceService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class EquisComponentInsertionService {
    constructor(componentFactoryResolver, componentPersistanceService, appRef, injector, rendererFactory) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.componentPersistanceService = componentPersistanceService;
        this.appRef = appRef;
        this.injector = injector;
        this.renderer = rendererFactory.createRenderer(null, null);
    }
    getComponentInstance(componentId) {
        return this.componentPersistanceService.getElementInstance(componentId);
    }
    getComponentParent(componentId) {
        return this.componentPersistanceService.getElementParent(componentId);
    }
    create(component, parent) {
        const componentFactory = this.componentFactoryResolver
            .resolveComponentFactory(component)
            .create(this.injector);
        this.appRef.attachView(componentFactory.hostView);
        const domElem = componentFactory.hostView
            .rootNodes[0];
        this.renderer.appendChild(parent, domElem);
        return this.componentPersistanceService.addElement(componentFactory, parent);
    }
    setProperty(componentId, key, value) {
        const componentInstance = this.getComponentInstance(componentId);
        componentInstance.instance[key] = value;
    }
    setStyle(componentId, style, value) {
        const componentInstance = this.getComponentInstance(componentId);
        this.renderer.setStyle(componentInstance.location.nativeElement.children[0], style, `${value}`);
    }
    addClass(componentId, className) {
        const componentInstance = this.getComponentInstance(componentId);
        this.renderer.addClass(componentInstance.location.nativeElement.children[0], className);
    }
    setPosition(componentId, elementPosition) {
        const componentInstance = this.getComponentInstance(componentId);
        let value;
        for (const styleName in elementPosition) {
            if (styleName) {
                value =
                    styleName === 'position'
                        ? `${elementPosition[styleName]}`
                        : `${elementPosition[styleName]}px`;
                this.renderer.setStyle(componentInstance.location.nativeElement.children[0], `${styleName}`, `${value}`);
            }
        }
    }
    destroy(componentId) {
        const componentInstance = this.getComponentInstance(componentId);
        componentInstance.destroy();
        this.componentPersistanceService.removeElement(componentId);
    }
}
EquisComponentInsertionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisComponentInsertionService, deps: [{ token: i0.ComponentFactoryResolver }, { token: EquisComponentPersistanceService }, { token: i0.ApplicationRef }, { token: i0.Injector }, { token: i0.RendererFactory2 }], target: i0.ɵɵFactoryTarget.Injectable });
EquisComponentInsertionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisComponentInsertionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisComponentInsertionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i0.ComponentFactoryResolver }, { type: EquisComponentPersistanceService }, { type: i0.ApplicationRef }, { type: i0.Injector }, { type: i0.RendererFactory2 }]; } });

class EquisDocumentService {
    constructor(platformId, document) {
        this.document = document;
        if (!isPlatformBrowser(platformId)) {
            this._document = {
                getElementById: (id) => new HTMLElement(),
                getElementsByClassName: (className) => new HTMLCollection(),
                getElementsByName: (name) => new NodeList(),
                getElementsByTagName: (name) => new NodeList(),
                documentElement: () => new HTMLElement(),
                body: () => new HTMLBodyElement(),
            };
        }
        else {
            this._document = this.document;
        }
    }
    get nativeDocument() {
        return this._document;
    }
    getWidthScreen(includeScroll = true) {
        const documentWidths = [
            this._document.body.offsetWidth,
            this._document.documentElement.offsetWidth,
            this._document.documentElement.clientWidth,
        ];
        if (includeScroll) {
            documentWidths.push(this._document.body.scrollWidth, this._document.documentElement.scrollWidth);
        }
        return Math.max(...documentWidths);
    }
    getHeightScreen(includeScroll) {
        const documentHeights = [
            this._document.body.offsetHeight,
            this._document.documentElement.offsetHeight,
            this._document.documentElement.clientHeight,
        ];
        if (includeScroll) {
            documentHeights.push(this._document.body.scrollHeight, this._document.documentElement.scrollHeight);
        }
        return Math.max(...documentHeights);
    }
}
EquisDocumentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDocumentService, deps: [{ token: PLATFORM_ID }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable });
EquisDocumentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDocumentService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDocumentService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; } });

class EquisWindowService {
    constructor(platformId) {
        if (!isPlatformBrowser(platformId)) {
            this._window = {
                navigator: { userAgent: 'WIP' },
                getComputedStyle: (element, pseudoElt) => new Object(),
            };
        }
        else {
            this._window = window;
        }
    }
    get nativeWindow() {
        return this._window;
    }
    getBrowser() {
        const agent = this.nativeWindow.navigator.userAgent.toLowerCase();
        switch (true // https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
        ) {
            case agent.indexOf('edge') > -1:
                return 'edge';
            case agent.indexOf('opr') > -1 && !!window.opr:
                return 'opera';
            case agent.indexOf('chrome') > -1 && !!window.chrome:
                return 'chrome';
            case agent.indexOf('trident') > -1:
                return 'ie';
            case agent.indexOf('firefox') > -1:
                return 'firefox';
            case agent.indexOf('safari') > -1:
                return 'safari';
            default:
                return 'none';
        }
    }
}
EquisWindowService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisWindowService, deps: [{ token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Injectable });
EquisWindowService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisWindowService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisWindowService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }]; } });

class EquisNavigatorService {
    constructor(_window, userAgent, platformId) {
        this._window = _window;
        this.userAgent = userAgent;
        this.platformId = platformId;
    }
    // see: https://stackoverflow.com/questions/3514784/what-is-the-best-way-to-detect-a-mobile-device
    get isMobile() {
        let isMobile = false;
        // prettier-ignore
        // eslint-disable-next-line max-len
        const regexUA = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;
        // prettier-ignore
        // eslint-disable-next-line max-len
        const uaStr = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i;
        let isRegexUA;
        let isUaStr;
        if (this.isBrowser) {
            isRegexUA = regexUA.test(this._window.nativeWindow.navigator.userAgent);
            isUaStr = uaStr.test(this._window.nativeWindow.navigator.userAgent.substr(0, 4));
        }
        else {
            isRegexUA = regexUA.test(this.userAgent);
            isUaStr = uaStr.test(this.userAgent.substr(0, 4));
        }
        if (isRegexUA || isUaStr) {
            isMobile = true;
        }
        return isMobile;
    }
    get isGoogleBot() {
        return /bot|googlebot|crawler|spider|robot|crawling/i.test(this._window.nativeWindow.navigator.userAgent);
    }
    get isBrowser() {
        return isPlatformBrowser(this.platformId);
    }
    get isServer() {
        return isPlatformServer(this.platformId);
    }
}
EquisNavigatorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisNavigatorService, deps: [{ token: EquisWindowService }, { token: 'userAgent', optional: true }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Injectable });
EquisNavigatorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisNavigatorService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisNavigatorService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: EquisWindowService }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['userAgent']
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }]; } });

class EquisKeypressService {
    constructor(documentService, navigationService) {
        this.documentService = documentService;
        this.navigationService = navigationService;
        this.keypressSubscription = new Subscription();
    }
    suscribeKeyPress(name) {
        if (this.navigationService.isBrowser) {
            const subject = new Subject();
            this.keypressSubscription = fromEvent(this.documentService.nativeDocument.querySelector('body'), 'keydown').subscribe((event) => {
                if (name && name === event.key) {
                    subject.next(true);
                }
                else {
                    subject.next(event.key);
                }
            });
            return subject.asObservable();
        }
        return of(null);
    }
    // usar solamente cuando se necesita una sola.
    keyPressEscape() {
        return this.suscribeKeyPress('Escape');
    }
    keyPressTab() {
        return this.suscribeKeyPress('Tab');
    }
    keyPressEnter() {
        return this.suscribeKeyPress('Enter');
    }
    keyPressSpace() {
        return this.suscribeKeyPress(' ');
    }
    keypressUnsubscription() {
        this.keypressSubscription.unsubscribe();
    }
}
EquisKeypressService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisKeypressService, deps: [{ token: EquisDocumentService }, { token: EquisNavigatorService }], target: i0.ɵɵFactoryTarget.Injectable });
EquisKeypressService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisKeypressService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisKeypressService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: EquisDocumentService }, { type: EquisNavigatorService }]; } });

class ModalDialogOptions {
}

class EquisModalDialogInstanceService {
    constructor() {
        this.componentRefs = [];
    }
    closeAnyExistingModalDialog() {
        while (this.componentRefs.length) {
            this.componentRefs[this.componentRefs.length - 1].destroy();
        }
    }
    saveExistingModalDialog(componentRef) {
        this.componentRefs = [...this.componentRefs, componentRef];
        componentRef.onDestroy(() => {
            this.componentRefs.pop();
        });
    }
}
EquisModalDialogInstanceService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogInstanceService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
EquisModalDialogInstanceService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogInstanceService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogInstanceService, decorators: [{
            type: Injectable
        }] });

class DialogInjector {
    constructor(_parentInjector, _additionalTokens) {
        this._parentInjector = _parentInjector;
        this._additionalTokens = _additionalTokens;
    }
    get(token, notFoundValue, flags) {
        const value = this._additionalTokens.get(token);
        if (value) {
            return value;
        }
        return this._parentInjector.get(token, notFoundValue);
    }
}

class EquisModalDialogService {
    constructor(appRef, injector, documentService, componentFactoryResolver, modalDialogInstanceService) {
        this.appRef = appRef;
        this.injector = injector;
        this.documentService = documentService;
        this.componentFactoryResolver = componentFactoryResolver;
        this.modalDialogInstanceService = modalDialogInstanceService;
    }
    openDialog(componentType, options) {
        setTimeout(() => {
            if (!options.placeOnTop) {
                this.modalDialogInstanceService.closeAnyExistingModalDialog();
            }
            const map = new WeakMap();
            map.set(ModalDialogOptions, options);
            const factory = this.componentFactoryResolver.resolveComponentFactory(options.childComponent);
            const componentRef = factory.create(new DialogInjector(this.injector, map));
            this.dialogComponentRef = componentRef;
            this.appRef.attachView(this.dialogComponentRef.hostView);
            this.isOverlay = options.isOverlay;
            if (options.isOverlay) {
                this.overlayDiv =
                    this.documentService.nativeDocument.createElement('div');
                this.overlayDiv.id = options.id ? `${options.id}-overlay` : 'overlay';
                this.overlayDiv.style.position = 'fixed';
                this.overlayDiv.style.background = 'rgb(51, 51, 51)';
                this.overlayDiv.style.opacity = ' 0.9';
                this.overlayDiv.style.overflow = 'hidden';
                this.overlayDiv.style.top = '0';
                this.overlayDiv.style.left = '0';
                this.overlayDiv.style.right = '0';
                this.overlayDiv.style.bottom = '0';
                this.overlayDiv.style.width = '100%';
                this.overlayDiv.style.zIndex = '800';
                this.overlayDiv.style.height =
                    this.documentService.nativeDocument.body.style.height;
                this.documentService.nativeDocument.body.appendChild(this.overlayDiv);
            }
            const domElem = componentRef.hostView
                .rootNodes[0];
            if (options.id) {
                domElem.id = options.id;
            }
            this.documentService.nativeDocument.body.appendChild(domElem);
            Object.assign(this.dialogComponentRef.instance, options);
            this.modalDialogInstanceService.saveExistingModalDialog(componentRef);
        }, 0);
    }
    close() {
        setTimeout(() => {
            if (this.dialogComponentRef) {
                if (this.isOverlay &&
                    this.documentService.nativeDocument.getElementById(this.overlayDiv.id)) {
                    this.documentService.nativeDocument.body.removeChild(this.overlayDiv);
                }
                this.appRef.detachView(this.dialogComponentRef.hostView);
                this.dialogComponentRef.destroy();
                this.documentService.nativeDocument.body.style.overflow = 'inherit';
            }
        }, 0);
    }
}
EquisModalDialogService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogService, deps: [{ token: i0.ApplicationRef }, { token: i0.Injector }, { token: EquisDocumentService }, { token: ComponentFactoryResolver }, { token: EquisModalDialogInstanceService }], target: i0.ɵɵFactoryTarget.Injectable });
EquisModalDialogService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisModalDialogService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i0.ApplicationRef }, { type: i0.Injector }, { type: EquisDocumentService }, { type: i0.ComponentFactoryResolver, decorators: [{
                    type: Inject,
                    args: [ComponentFactoryResolver]
                }] }, { type: EquisModalDialogInstanceService, decorators: [{
                    type: Inject,
                    args: [EquisModalDialogInstanceService]
                }] }]; } });

class EquisStringManipulationService {
    westernArabicNumeralsOnly(style) {
        return style && style.match(/\d+/g)
            ? style.match(/\d+/g).map(Number)[0]
            : null;
    }
}
EquisStringManipulationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisStringManipulationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
EquisStringManipulationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisStringManipulationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisStringManipulationService, decorators: [{
            type: Injectable
        }] });

class EquisWindowScrollingService {
    constructor(document) {
        this.document = document;
        this.styleTag = this.buildStyleElement();
    }
    disable() {
        this.document.body.appendChild(this.styleTag);
    }
    enable() {
        this.document.body.removeChild(this.styleTag);
    }
    buildStyleElement() {
        const style = this.document.createElement('style');
        style.textContent = `
    body {
      overflow: hidden !important;
    }`;
        return style;
    }
}
EquisWindowScrollingService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisWindowScrollingService, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable });
EquisWindowScrollingService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisWindowScrollingService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisWindowScrollingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; } });

const whiteSpaceRegex = /\s/g;
const notNumbersRegex = /[^0-9,]/g;
const comasRegex = /[,]+/g;
const decimalSeparator = ',';
class EquisCurrencyMaskService {
    constructor() { }
    setMask(input, currency = EquisCurrencyTypes.ARS) {
        let value = input.value
            .replace(whiteSpaceRegex, '')
            .replace('.', decimalSeparator)
            .replace(notNumbersRegex, '');
        const [integer, decimal] = value.split(',');
        value = decimal
            ? `${integer}${decimalSeparator}${decimal.substring(0, 2)}`
            : value.replace(comasRegex, decimalSeparator);
        input.value = value ? `${currency}${value}` : value;
    }
}
EquisCurrencyMaskService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisCurrencyMaskService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
EquisCurrencyMaskService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisCurrencyMaskService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisCurrencyMaskService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class EquisServicesModule {
    static forRoot() {
        return {
            ngModule: EquisServicesModule,
            providers: [
                EquisChildCheckService,
                EquisComponentInsertionService,
                EquisComponentPersistanceService,
                EquisDocumentService,
                EquisKeypressService,
                EquisModalDialogService,
                EquisModalDialogInstanceService,
                EquisStringManipulationService,
                EquisWindowService,
                EquisNavigatorService,
                EquisWindowScrollingService,
                EquisCurrencyMaskService,
            ],
        };
    }
}
EquisServicesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisServicesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EquisServicesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: EquisServicesModule });
EquisServicesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisServicesModule, providers: [
        EquisChildCheckService,
        EquisComponentInsertionService,
        EquisComponentPersistanceService,
        EquisDocumentService,
        EquisKeypressService,
        EquisModalDialogService,
        EquisModalDialogInstanceService,
        EquisStringManipulationService,
        EquisWindowService,
        EquisNavigatorService,
        EquisWindowScrollingService,
        EquisCurrencyMaskService,
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisServicesModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        EquisChildCheckService,
                        EquisComponentInsertionService,
                        EquisComponentPersistanceService,
                        EquisDocumentService,
                        EquisKeypressService,
                        EquisModalDialogService,
                        EquisModalDialogInstanceService,
                        EquisStringManipulationService,
                        EquisWindowService,
                        EquisNavigatorService,
                        EquisWindowScrollingService,
                        EquisCurrencyMaskService,
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { DialogInjector, EquisChildCheckService, EquisComponentInsertionService, EquisComponentPersistanceService, EquisCurrencyMaskService, EquisDocumentService, EquisKeypressService, EquisModalDialogInstanceService, EquisModalDialogService, EquisNavigatorService, EquisServicesModule, EquisStringManipulationService, EquisWindowScrollingService, EquisWindowService, ModalDialogOptions };
